<ng-container *ngIf="reportGenerationForm != null" [formGroup]="reportGenerationForm">
  <div class="grid">
    <div class="form-group">
      <label>Timeframe</label>
      <lib-date-range-picker
        [required]="true"
        [allowSameDate]="true"
        formControlName="dateRange"></lib-date-range-picker>
    </div>
    <div class="form-group">
      <label for="timeOffCodes">Time Off Codes</label>
      <lib-multiselect
        id="timeOffCodes"
        [options]="timeOffCodes"
        formControlName="timeOffCodes"
        [allowSelectAll]="true"></lib-multiselect>
      <small
        class="form-text error-text"
        *ngIf="reportGenerationForm.get('timeOffCodes').errors?.mustSelectCode"
        >*You must select at least one code.</small
      >
    </div>
    <div>
      <label for="employeeStatus">Employee Status</label>
      <lib-multiselect
        id="employeeStatus"
        [options]="statuses"
        formControlName="employeeStatus"
        [allowSelectAll]="true"></lib-multiselect>
    </div>
    <div *ngIf="divisions.length > 0">
      <label for="department">Departments</label>
      <lib-multiselect
        id="department"
        [options]="divisions"
        formControlName="department"
        [allowSelectAll]="true"></lib-multiselect>
    </div>
    <div>
      <label>Employee</label>
      <lib-multiselect
        defaultButtonText="Select Employees"
        [options]="peopleObs | async"
        formControlName="employee"
        [allowSelectAll]="true"></lib-multiselect>
    </div>
    <div class="form-group">
      <label for="groupBy">Group By:</label>
      <select formControlName="groupBy" id="groupBy" class="form-control">
        <option *ngFor="let opt of groupBy" [value]="opt">{{ opt }}</option>
      </select>
    </div>
    <div class="form-group">
      <label for="firstSortBy">Sort By:</label>
      <select formControlName="firstSortBy" id="firstSortBy" class="form-control">
        <option *ngFor="let opt of sort" [value]="opt">
          <span *ngIf="opt == 'Employee Number'">Employee ID</span>
          <span *ngIf="opt != 'Employee Number'">{{ opt }}</span>
        </option>
      </select>
    </div>
  </div>

  <lib-report-buttons
    [disabled]="reportGenerationForm.invalid"
    (generateReport)="generateReport()"
    (downloadReport)="downloadReport($event)"></lib-report-buttons>
</ng-container>
